export default __webpack_public_path__ + "static/media/16.d572245a.png";